export default __webpack_public_path__ + "static/media/shirt.95d18d43.webp";